var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormMembers.jinja');
require('./SubmissionFormMembers.less');

var SubmissionFormMembersItem = require('submissions/components/SubmissionForm/SubmissionFormMembersItem');
var SubmissionFormMembersItemTemplate = require('submissions/components/SubmissionForm/SubmissionFormMembersItemRuntime.jinja');

require('jquery-ui/ui/widgets/sortable');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'click .SubmissionFormMembers-add': 'onAddClick'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onGetHeadInfo', 'onItemDelete', 'onItemCollapseToggle');

        var self = this;

        this.$('.SubmissionFormMembersItem').each(function () {
            var itemInstance = new SubmissionFormMembersItem({
                el: this
            });

            itemInstance.on('delete', self.onItemDelete);
            itemInstance.on('collapse-toggle', self.onItemCollapseToggle);

            $(this).data('instance', itemInstance);
        });

        app.vent.on('submission-get-head-info', this.onGetHeadInfo);

        var handleOffset;

        var $wrapper = this.$('.SubmissionFormMembers-wrapper');

        this.sortable = this.$('.SubmissionFormMembers-wrapper').sortable({
            handle: '.SubmissionFormMembersItem-reorder',
            cursorAt: { left: 0, top: 0 },
            axis: 'y',
            scroll: true,
            scrollSensitivity: 40,
            scrollSpeed: 20,
            tolerance: 'pointer',
            cursor: 'move',
            stop: function(event, ui) {
                handleOffset = undefined;
            },
            sort: function(event, ui) {
                if (handleOffset === undefined) {
                    handleOffset = ui.originalPosition.top - ui.position.top;
                }
                var $target = $(event.target);
                var top = event.clientY - $wrapper[0].getBoundingClientRect().top + handleOffset;
                ui.helper.css({'top': top + 'px'});
            },
        });

        // this.$('.SubmissionFormMembers-wrapper').disableSelection();

        // this.$('.SubmissionFormMembers-wrapper').sortable('instance').cssPosition = 'absolute';

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {

        app.vent.off('submission-get-head-info', this.onGetHeadInfo);

        var self = this;

        this.$('.SubmissionFormMembersItem').each(function () {
            var itemInstance = $(this).data('instance');

            itemInstance.off('delete', self.onItemDelete);
            itemInstance.off('collapse-toggle', self.onItemCollapseToggle);

            itemInstance.deactivate();
        });

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    onGetHeadInfo: function () {
        var data = this.getFormData().team[0]; //first member is always head

        app.vent.trigger('submission-head-info', data);
    },


    onItemDelete: function() {
        this.sortable.sortable('refresh');
        this.sortable.sortable('refreshPositions');
    },

    onItemCollapseToggle: function() {
        var sortable =  this.sortable;
        setTimeout(function () {
            sortable.sortable('refreshPositions');
        }, 200);
    },


    onAddClick: function () {
        var $template = $(SubmissionFormMembersItemTemplate.render({
            data: {},
            isRequired: false,
            isHead: false
        }));

        this.$('.SubmissionFormMembers-wrapper').append($template);

        var itemInstance = new SubmissionFormMembersItem({
            el: $template[0]
        });

        itemInstance.on('delete', this.onItemDelete);
        itemInstance.on('collapse-toggle', this.onItemCollapseToggle);

        $template.data('instance', itemInstance);

        this.sortable.sortable('refresh');
        this.sortable.sortable('refreshPositions');
    },


    checkRequired: function () {
        var noErrors = true;

        this.$('.SubmissionFormMembersItem').each(function (ind) {
            var itemInstance = $(this).data('instance');
            noErrors = noErrors && itemInstance.checkRequired();
        });

        return noErrors;
    },


    getFormData: function () {
        var members = [];

        this.$('.SubmissionFormMembersItem').each(function (ind) {
            var itemInstance = $(this).data('instance');
            var data = itemInstance.getData();
            data.order = ind;

            members.push(data);
        });

        return {
            team: members
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormMembers.js
// module id = 120
// module chunks = 0